import { IconList } from "@tabler/icons-react";
import type { FC } from "react";
import { useState } from "react";
import {
  Button as AriaButton,
  Dialog,
  DialogTrigger,
  Popover,
} from "react-aria-components";

import { twMerge } from "tailwind-merge";
import { buildCallOutlineTriggerLabel } from "./callOutlineTriggerLabel.js";
import {
  TeammateAccountCallOutlineNavigation,
  type CallPosition,
  type TeammateAccountCallOutlineNavigationProps,
} from "./teammateAccountCallOutlineNavigation.js";

export interface CallOutlineNavigationPopoverProps extends TeammateAccountCallOutlineNavigationProps {}

export const CallOutlineNavigationPopover: FC<
  CallOutlineNavigationPopoverProps
> = (props) => {
  const {
    callOutline,
    isLoading,
    isError,
    callPosition,
    onCallPositionRequest,
  } = props;

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const triggerLabel = buildCallOutlineTriggerLabel({
    callOutline,
    callPosition,
  });

  return (
    <div className="w-full">
      <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
        <AriaButton
          className="inline-block w-full"
          aria-label="Open call outline navigation"
        >
          <div
            className={twMerge(
              "inline-flex w-full max-w-full items-center gap-2 truncate rounded-md border border-border-light bg-gray-50 px-2 py-1 text-xs text-gray-700 hover:bg-gray-100",
              isOpen ? "bg-gray-100" : "",
            )}
          >
            <span className="font-medium text-foreground">
              <IconList className="h-4 w-4" />
            </span>
            <span className="truncate" title={triggerLabel}>
              {triggerLabel}
            </span>
          </div>
        </AriaButton>

        <Popover
          placement="bottom start"
          isNonModal
          className="z-20 w-(--trigger-width) rounded-md border border-border-light bg-white shadow-xl"
        >
          <Dialog>
            <div className="max-h-[50vh] overflow-y-auto">
              <TeammateAccountCallOutlineNavigation
                callOutline={callOutline}
                isLoading={isLoading}
                isError={isError}
                callPosition={callPosition}
                onCallPositionRequest={(position: CallPosition) => {
                  onCallPositionRequest?.(position);
                  setIsOpen(false);
                }}
                shouldAutoScrollToActive={false}
              />
            </div>
          </Dialog>
        </Popover>
      </DialogTrigger>
    </div>
  );
};
